import React, { useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";

import NumericControl from "../../../components/molecules/NumericControl";

import useFetchHook from "../../../components/fetchHook";
import getPCPUrl from "../../../components/pcpUrl";



export default function MortgageAnalyzer() {

  return (
    <Row>
      <Col lg={{ span: 6, offset: 3 }}>
        <MortgageCalc/>
      </Col>
    </Row>
  );
}


function MortgageCalc(props) {
  const [principal, setPrincipal] = useState("100000");
  const [years, setYears] = useState("10");
  const [frequency, setFrequency] = useState("12");
  const [rate, setRate] = useState("3.5");
  //const [{ data, isLoading, isError }, doFetch] = useFetchHook('http://localhost:7071/api/MortgageCalc', createEmptySchedule() );
  const [{ data, isLoading, isError }, doFetch] = useFetchHook( getPCPUrl() + 'MortgageCalc', createEmptySchedule() );

  
  function createEmptySchedule() {
    var schedule = {
      originalPrincipal: 0,
      months: 0,
      payment: 0,
      currentPrincipal: 0,
      totalInterest: 0,
  
      schedule: []
    }
  
    return schedule;
  }

  function onClick(event) {
    event.preventDefault();

    var params = { 
      principal: parseFloat(principal),
      years: parseInt(years),
      frequency: parseInt(frequency),
      rate: parseFloat(rate)
    };

    doFetch(params);
  }


  return (
    <Form>
      <NumericControl label="Mortgage Amount" value={principal} onChange={setPrincipal} />

      <NumericControl label="Years" value={years} onChange={setYears} />

      <NumericControl label="Frequency" value={frequency} onChange={setFrequency} />

      <NumericControl label="Rate" value={rate} onChange={setRate} />

      <Button onClick={onClick}>Calculate</Button>

      <MortgageSchedule results={data} />

    </Form>  

  );
}


function MortgageSchedule(props) {

  function row(s) {
    return (
      <tr>
        <td>{s.month}</td>
        <td>{s.principal}</td>
        <td>{s.interest}</td>
      </tr>
    );
  }

  return (
    <React.Fragment>
      <h4>{props.results.originalPrincipal}</h4>
      <h4>{props.results.months}</h4>
      <h4>{props.results.payment}</h4>
      <h4>{props.results.currentPrincipal}</h4>
      <h4>{props.results.totalInterest}</h4>

      <table>
      {props.results.schedule.map( t => row(t) )}
      </table>
    </React.Fragment>

  );
}



